import MediaMasterPage from './MediaMasterPage';

export default MediaMasterPage;
